module.exports = __webpack_public_path__ + "static/media/Colette Wing Super King Headboard - 200 cm_Blush Pink.6c47fb99.png";